export enum PaymentMethodType {
    CARD = 'Card',
    CASH_APP = 'Cash App',
    AMAZON_PAY = 'Amazon Pay',
    KLARNA = 'Klarna',
    LINK = 'Link'
}